/* lib/railFamilies.js — which technician pages belong to which product line (batch 14).
 *
 * User (2026-10-03): "make sure the Fabric Library only shows when you click Indoor or
 * Outdoor — when you click Indoor or Outdoor only the Fabric Library shows in the material
 * library, and Dashboard / Catalog / Products like normally. Kitchen and Systems stay as
 * they are right now." So:
 *   · Kitchen / Systems   → every library page EXCEPT the fabric pages;
 *   · Indoor / Outdoor    → Dashboard, Catalog, Products (+ the tools) and THEIR fabric pages
 *                           (Indoor: Indoor Fabric + Leather · Outdoor: Outdoor Fabric + Rope);
 *                           the cabinet material, equipment and fittings libraries are hidden.
 * Pure — the rail, the palette and the redirect guard share it; the tests pin it. */

export const FURNITURE_LINES = ["indoor", "outdoor"];
export const FABRIC_PAGES_BY_LINE = { indoor: ["fabric-in", "fabric-lt"], outdoor: ["fabric-out", "fabric-rp"] };
export const FABRIC_PAGES = ["fabric-in", "fabric-lt", "fabric-out", "fabric-rp"];
const LINE_OF_FABRIC_PAGE = { "fabric-in": "indoor", "fabric-lt": "indoor", "fabric-out": "outdoor", "fabric-rp": "outdoor" };

/** the cabinet-making library pages (materials, finishes, equipment, fittings) */
const CABINET_LIB_PAGES = ["materials", "finishes", "accessories", "pglib", "handles", "gola", "plinth", "lighting",
  "worktops", "backsplash", "side-panels"];
export function isCabinetLibPage(view) {
  const v = String(view || "");
  return CABINET_LIB_PAGES.indexOf(v) >= 0 || /^eq-/.test(v);
}

export const isFurnitureLine = (line) => FURNITURE_LINES.indexOf(String(line || "")) >= 0;

/** may `view` show while the top bar is on `line`? */
export function pageVisibleForLine(view, line) {
  const v = String(view || "");
  if (FABRIC_PAGES.indexOf(v) >= 0) return isFurnitureLine(line) && FABRIC_PAGES_BY_LINE[line].indexOf(v) >= 0;
  if (isCabinetLibPage(v)) return !isFurnitureLine(line);
  return true;                                   // dashboard, catalog, products, the SKU bench, tools
}

/** the line a fabric page belongs to (a deep link to /catalog?v=fabric-in opens Indoor) */
export function lineForFabricPage(view) { return LINE_OF_FABRIC_PAGE[String(view || "")] || null; }

/** where a page that is hidden for `line` should go instead (null = it may stay) */
export function redirectForLine(view, line) {
  if (pageVisibleForLine(view, line)) return null;
  const v = String(view || "");
  if (FABRIC_PAGES.indexOf(v) >= 0 && isFurnitureLine(line)) return FABRIC_PAGES_BY_LINE[line][0];   // indoor ⇄ outdoor
  return "dashboard";
}
